import React, { useState } from 'react'
import styled from 'styled-components'

import { Heading2, Heading4 } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Subheading = styled(Heading4)`
  margin-bottom: 16px;
  padding: 4px 8px;
`

const Row = styled.div`
  display: flex;
  column-gap: 32px;
  :not(:last-child) {
    margin-bottom: 56px;
  }
`

const Column = styled.div`
  width: calc(100% / 3);
`

const List = styled.ul``

const Item = styled.li`
  :not(:last-child) {
    margin-bottom: 8px;
  }
`

const Button = styled.button`
  width: 100%;
  padding: 4px 8px;
  border-radius: 4px;
  text-align: left;
  font-weight: 600;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: 0.25px;
  border: 2px solid transparent;
  outline: none;
  :hover {
    background-color: #f0f1f6;
  }
  :focus-visible {
    border: 2px solid #458fff;
  }
  :active {
    background-color: #ff8de3;
    border: 2px solid transparent;
  }
  :disabled {
    color: #ac9eb9;
    background-color: transparent;
    border: 2px solid transparent;
  }
  ${(p) => p.hovered && 'background-color: #f0f1f6;'}
  ${(p) => p.focused && 'border: 2px solid #458fff;'}
  ${(p) => p.pressed && 'background-color: #ff8de3; border: 2px solid transparent;'}
  ${(p) => p.selected && 'background-color: #E6E2FC !important; border: 2px solid transparent !important;'}
  ${(p) => p.selectedStyle && 'background-color: #E6E2FC !important; border: 2px solid transparent !important;'}
`

const Navigation = () => {
  const [selected, setSelected] = useState('')
  return (
    <>
      <Heading>Navigation</Heading>
      <Row>
        <Column>
          <Subheading>Default</Subheading>
          <List>
            <Item>
              <Button onClick={() => setSelected(1)} selected={selected === 1}>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(2)} selected={selected === 2}>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(3)} selected={selected === 3}>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(4)} selected={selected === 4}>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(5)} selected={selected === 5}>
                Menu option
              </Button>
            </Item>
          </List>
        </Column>
        <Column>
          <Subheading>Hover</Subheading>
          <List>
            <Item>
              <Button onClick={() => setSelected(6)} selected={selected === 6}>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(7)} selected={selected === 7}>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(8)} selected={selected === 8} hovered>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(9)} selected={selected === 9}>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(10)} selected={selected === 10}>
                Menu option
              </Button>
            </Item>
          </List>
        </Column>
        <Column>
          <Subheading>Focussed</Subheading>
          <List>
            <Item>
              <Button onClick={() => setSelected(11)} selected={selected === 11}>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(12)} selected={selected === 12}>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(13)} selected={selected === 13} focused>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(14)} selected={selected === 14}>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(15)} selected={selected === 15}>
                Menu option
              </Button>
            </Item>
          </List>
        </Column>
      </Row>
      <Row>
        <Column>
          <Subheading>Pressed</Subheading>
          <List>
            <Item>
              <Button onClick={() => setSelected(16)} selected={selected === 16}>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(17)} selected={selected === 17}>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(18)} selected={selected === 18} pressed>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(19)} selected={selected === 19}>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(20)} selected={selected === 20}>
                Menu option
              </Button>
            </Item>
          </List>
        </Column>
        <Column>
          <Subheading>Selected</Subheading>
          <List>
            <Item>
              <Button onClick={() => setSelected(21)} selected={selected === 21}>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(22)} selected={selected === 22}>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(23)} selected={selected === 23} selectedStyle>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(24)} selected={selected === 24}>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(25)} selected={selected === 25}>
                Menu option
              </Button>
            </Item>
          </List>
        </Column>
        <Column>
          <Subheading>Disabled</Subheading>
          <List>
            <Item>
              <Button onClick={() => setSelected(26)} selected={selected === 26}>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(27)} selected={selected === 27}>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(28)} selected={selected === 28} disabled>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(29)} selected={selected === 29}>
                Menu option
              </Button>
            </Item>
            <Item>
              <Button onClick={() => setSelected(30)} selected={selected === 30}>
                Menu option
              </Button>
            </Item>
          </List>
        </Column>
      </Row>
    </>
  )
}

export default Navigation
